import { EventTypeIdentifier } from '../enums';

export enum DeviceState {
  Unknown = 0,
  Healthy = 1,
  Unhealthy = 2,
  Alert = 3,
  UnhealthyGeneric = -1, // custom value for the FE
}

export enum InService {
  OutOfService = 'OOS',
  InService = 'INS',
  AtVendor = 'ATV',
  AtShop = 'ATS',
  LegalHold = 'LEG',
  OutOfServiceGeneric = 'OOS_ANY', // custom value for the FE
}

export enum EventsIn72Hours {
  HasEvents = 'hasEvents',
  NoEvents = 'noEvents',
}

export enum BusMovingStatus {
  Moving = 'MOVING',
  NotMoving = 'NOT_MOVING',
  Unknown = 'UNKNOWN',
}

interface RouteVersion {
  type: EventTypeIdentifier;
  version: string;
  date: string;
}

export interface LastEvent {
  event_id: number;
  captured_at: string;
  event_type: EventTypeIdentifier;
}

export interface StatusCategory {
  status: DeviceState;
  [key: string]: DeviceState;
}

interface CommsStatusCategory extends StatusCategory {
  comms: DeviceState;
  event_upload: DeviceState;
  lte: DeviceState;
}

interface PositionalityStatusCategory extends StatusCategory {
  antenna: DeviceState;
  can: DeviceState;
  gps: DeviceState;
  gps_accuracy: DeviceState;
  ublox_gnss: DeviceState;
}

export interface DeviceHealth {
  id: string;
  in_service: InService;
  in_service_time: any;
  serial_number: string;
  gtfs_bus_moving_status: BusMovingStatus;
  vehicle_id: number;
  vehicle_name: string;
  route_name?: string;
  installed_ota_id: number;
  depot: string;
  distance_from_depot: number;
  route_id: number;
  bus_driving_status: number;
  statuses: {
    [category: string]: StatusCategory;
    ABLE: StatusCategory & { able?: DeviceState };
    Comms: CommsStatusCategory;
    'Context Cam': StatusCategory & { 'camera-context': DeviceState };
    'Context cam': StatusCategory & { 'camera-context': DeviceState };
    'LPR Cam': StatusCategory & { 'camera-lpr': DeviceState };
    'LPR cam': StatusCategory & { 'camera-lpr': DeviceState };
    'Last Check-in': StatusCategory & { last_check_in: DeviceState };
    MCU: StatusCategory & { mcutemp: DeviceState };
    OTA: StatusCategory & { ota_update: DeviceState };
    Positionality: PositionalityStatusCategory;
    Gps: StatusCategory & { gps: DeviceState };
  };
  status: DeviceState;
  last_check_in?: any;
  created_at?: any;
  last_events?: LastEvent[];
  latest_event?: LastEvent;
  last_approved_event?: {
    event_id: string;
    captured_at: string;
  };
  jira_ticket?: null | {
    priority_name: string;
    status_name: string;
    summary: string;
    ticket_url: string;
  };
  ota_details: {
    is_ota_updated: boolean; // installed == assigned
    route_versions: RouteVersion[];
    ota_group_id: string;
    ota_group_name: string;
  };
  device_fw_version_info: {
    able_version: string | null;
    able_version_date: string | null;
    alpr_version: string | null;
    alpr_version_date: string | null;
    permitted_list_version: string | null;
    permitted_list_version_date: string | null;
    ublox_version: string | null;
    ublox_version_date: string | null;
  };
  device_hw_version_details: {
    device_hw_version_id: number;
    device_hw_version_name: string;
  };
  camera_version_details: {
    camera_version_id: number;
    camera_version_name: string;
  };
}

export interface DeviceHwVersion {
  created_at: string;
  device_hw_version_id: number;
  version_name: string;
}
